module.exports = __webpack_public_path__ + "media/images/shopping_cart_white-2161b7b826ea7ea44a91b22533df648c.svg";